<template>
  <div class="flex-grow-1 d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="modems"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :externalFilters="external"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h2 class="page-heading mr-auto">Активные модемы</h2>
        <div class="input-group mr-1" style="max-width: 27em">
          <div class="input-group-prepend">
            <span class="input-group-text">UID модема</span>
          </div>
          <input type="text" class="form-control"  v-model="uidFilter">
        </div>
        <button class="btn btn-sm btn-outline-primary mr-2" @click="save">Применить</button>
        <button class="btn btn-outline-primary mr-2" @click="commandsBroadcast()" v-if="data && $root.isAdmin()">Рассылка команд</button>
        <button class="btn btn-primary mr-2" @click="newModem()">Добавить модем</button>
        <btn-filters
          :data="data"
          endpoint="modems"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="modems"
        @sort-change="sortChange"
        @load-more="loadMore"
        :hasMore="hasMore"
        :loading="loading"
      >
        <el-table-column prop="uid" label="№ модема" sortable="custom" width="200">
          <template slot-scope="{row}">
            <router-link :to="`/modems/${row.uid}`">
              <div>{{ row.number }}</div>
              <div><small>{{ row.uid }}</small></div>
            </router-link>
          </template>
        </el-table-column>
        <table-column-serial-number prop="machines.serial_number" machine-prop="machine" sortable="custom"/>
        <el-table-column label="SIM">
          <template slot-scope="{row}">
            <div v-if="row.data && row.data.sim">SIM-карта: {{ row.data.sim }}</div>
            <div v-if="row.data && row.data.simchip">SIM-чип: {{ row.data.simchip }}</div>
          </template>
        </el-table-column>
        <table-column-date prop="last_command_at" label="Последняя команда" sortable="custom"/>
        <el-table-column label="Редактировать" width="180" align="center">
          <template slot-scope="{row}">
            <button class="btn btn-sm btn-outline-light" @click.stop="edit(row)">Редактировать</button>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import api from '@/api'
  import EditModal from '../../../components/modems/edit-modal.vue'
  import BroadcastModal from '../../../components/modems/broadcast-modal.vue'

  export default {
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        sort: {prop: 'uid', order: 'asc'},
        updateList: 0,
        uidFilter: null,
        external: null,
      }
    },
    computed: {
      modems () {
        return this.data.data
      },
    },
    methods: {
      newModem () {
        this.$root.showModal(EditModal, {id: null, uid: null, newModem: true}).then((value) => {
          if (value) {
            this.modems.unshift({
              id: value.modemId,
              uid: value.uid,
              machine: {
                id: value.machineId,
                serial_number: value.serial_number,
              },
            })
          }
        })
      },
      edit (modem) {
        let noCommands = modem.last_command_at === null
        this.$root.showModal(EditModal, {
          id: modem.id,
          currentMachineId: modem.machine ? modem.machine.id : undefined,
          currentMachineSerialNumber: modem.machine ? modem.machine.serial_number : undefined,
          uid: modem.uid,
          noCommands: noCommands,
          number: modem.number,
        }).then((value) => {
          if (value) {
            this.modems.forEach(function (item) {
              if (item.id === value.modemId) {
                if (!item.machine) {
                  item.machine = {}
                }
                item.machine.id = value.machineId
                item.machine.serial_number = value.serial_number
                if (noCommands) {
                  item.number = value.number
                }
              }
            })
          }
        })
      },
      commandsBroadcast () {
        this.$root.showModal(BroadcastModal, {
          filters: this.filtersValue,
          total: this.data.total,
        })
      },
      loadMore () {
        this.$refs.data.loadMore()
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = {
            prop: sort.prop,
            order,
          }
        } else {
          this.sort = null
        }
      },
      save () {
        let data = {}
        if (this.uidFilter) data.uid = this.uidFilter
        this.external = data
      }
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/modems/index/index.vue